import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  collectionsApi,
  type CreateCollectionInput,
  type UpdateCollectionInput,
} from '../api/collections.api.js';

const LIST_KEY = ['collections', 'list'];

export function useMyCollections() {
  return useQuery({
    queryKey: LIST_KEY,
    queryFn: () => collectionsApi.list(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCollectionDetails(id: string | null) {
  return useQuery({
    queryKey: ['collections', 'detail', id],
    queryFn: () => collectionsApi.details(id!),
    enabled: id !== null,
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateCollection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateCollectionInput) => collectionsApi.create(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['collections'] });
    },
  });
}

export function useUpdateCollection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: string; patch: UpdateCollectionInput }) =>
      collectionsApi.update(vars.id, vars.patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['collections'] });
    },
  });
}

export function useDeleteCollection() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => collectionsApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['collections'] });
    },
  });
}
